import constants from './constants';

// const { TASK_TYPES, TASK_FORMATS } = constants;

// const TASK_TYPES_DATA = {
//   [TASK_TYPES.AUTOMATED_TESTING]: {
//     id: TASK_TYPES.AUTOMATED_TESTING,
//     name: 'Автоматизированное тестирование',
//   },
//   [TASK_TYPES.EXPERT_REVIEW]: {
//     id: TASK_TYPES.EXPERT_REVIEW,
//     name: 'Экспертная проверка',
//   },
// };

// const TASK_FORMATS_DATA = {
//   [TASK_FORMATS.ONLINE]: {
//     id: TASK_FORMATS.ONLINE,
//     name: 'Онлайн',
//   },
//   [TASK_FORMATS.OFFLINE]: {
//     id: TASK_FORMATS.OFFLINE,
//     name: 'Офлайн',
//   },
// };

// const TASK_TYPES_LIST = Object.values(TASK_TYPES_DATA);
// const TASK_FORMATS_LIST = Object.values(TASK_FORMATS_DATA);

export default {};
